import { Card, CardBody, Col, Input, InputGroup } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { Secondary, SegmentedButtonsTitle, Success } from "../../../../../Constants/Constants";
import { SegmentedButtonsData1, SegmentedButtonsData2, SegmentedButtonsSubTitle } from "../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ButtonDropdownList from "./ButtonsWithDropdowns/ButtonDropdownList";

const SegmentedButtons = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={SegmentedButtonsTitle} span={SegmentedButtonsSubTitle} />
        <CardBody className="main-segment-btn card-wrapper input-group-wrapper">
          <InputGroup>
            <Btn color="info" outline>{Success}</Btn>
            <ButtonDropdownList color="info" split={true} span={true} divider={true} options={SegmentedButtonsData1} />
            <Input type="text" />
          </InputGroup>
          <InputGroup>
            <Input type="text" />
            <Btn color="secondary" outline>{Secondary}</Btn>
            <ButtonDropdownList color="secondary" split={true} span={true} divider={true} options={SegmentedButtonsData2} />
          </InputGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default SegmentedButtons;
